<template>
  <nav aria-label="Breadcrumb">
    <View as="ol" gap="xs" align="center" wrap="wrap" class="trail">
      <li v-for="(item, index) in items" :key="index" class="crumb">
        <Text v-if="index > 0" as="span" variant="body-small" color="secondary" aria-hidden="true">›</Text>
        <Link v-if="item.to && index < items.length - 1" :to="item.to" color="accent">{{ item.label }}</Link>
        <Text v-else as="span" variant="body-small" aria-current="page">{{ item.label }}</Text>
      </li>
    </View>
  </nav>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router';

import Link from './link.vue';
import Text from './text.vue';
import View from './view/view.vue';

export interface BreadcrumbItem {
  label: string;
  /** Where the crumb leads; the last crumb is the page itself and never a link */
  to?: RouteLocationRaw;
}

/** Where the page sits: its ancestors as links, the page itself last and plain */
defineProps<{ items: BreadcrumbItem[] }>();
</script>

<style scoped lang="scss">
.trail {
  margin: 0;
  padding: 0;
  list-style: none;
}

.crumb {
  display: flex;
  gap: var(--t-spacing-xs);
  align-items: center;
  min-width: 0;
  overflow-wrap: anywhere;
}
</style>
